module.exports = __webpack_public_path__ + "28e8b5d25720e8d6e6e5c457ea18977d.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/P28 - TempleApproach - LasCannons.jpg
// module id = 153
// module chunks = 0